/*
 * VELUNE — Layered Slideshow lazy loader
 *
 * The theme references this asset globally, but most pages do not render a
 * <layered-slideshow-component>. Keep the global payload tiny and load the
 * original implementation only on pages/sections that actually need it.
 */

let layeredSlideshowModule = null;

function hasLayeredSlideshow(root = document) {
  if (root instanceof Element && root.matches('layered-slideshow-component')) {
    return true;
  }

  return Boolean(root.querySelector?.('layered-slideshow-component'));
}

function loadLayeredSlideshow(root = document) {
  if (!hasLayeredSlideshow(root)) return null;

  if (!layeredSlideshowModule) {
    layeredSlideshowModule = import('./velune-audit-backup-layered-slideshow.js');
  }

  return layeredSlideshowModule;
}

/*
 * Module scripts in <head> are deferred, so the initial document has already
 * been parsed when this runs. If the component exists, load its implementation
 * immediately; otherwise the 18 KB core never needs to be downloaded.
 */
loadLayeredSlideshow();

/* Shopify Theme Editor can insert the section after initial page load. */
document.addEventListener('shopify:section:load', (event) => {
  loadLayeredSlideshow(event.target);
});

/*
 * Keep a named helper available for diagnostics without creating another
 * observer or permanent timer.
 */
window.__veluneLoadLayeredSlideshow = loadLayeredSlideshow;
